export const namespaced = true;

const initState = () => ({
  organizations: [],
  pagination: { total: 0, page: 1, limit: 20, totalPages: 0 },
  isLoading: false,
  error: null,
});

export const state = initState();

export const mutations = {
  SET_ORGANIZATIONS(state, organizations) {
    state.organizations = organizations;
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = { ...pagination };
  },
  SET_LOADING(state, val) {
    state.isLoading = val;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAN_STATE(state) {
    Object.assign(state, initState());
  },
};

export const actions = {
  cleanState({ commit }) {
    commit("CLEAN_STATE");
  },

  async importHomologations(_, { organizationId, records }) {
    const restClient = require("../../lib/restClient").default;
    return restClient.post("/api/v1/organizations/import-homologations", {
      organizationId,
      records,
    });
  },

  async getOrganizationHomologations(_, { organizationId }) {
    const restClient = require("../../lib/restClient").default;
    return restClient.get(`/api/v1/organizations/${organizationId}/homologations`);
  },

  async updateHomologation(_, { id, name }) {
    const restClient = require("../../lib/restClient").default;
    return restClient.patch(`/api/v1/organizations/homologations/${id}`, { name });
  },

  async fetchSysadminOrganizations({ commit }, params) {
    try {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      const restClient = require("../../lib/restClient").default;
      const { data } = await restClient.get("/api/v1/organizations", { params });
      commit("SET_ORGANIZATIONS", data.organizations);
      commit("SET_PAGINATION", data.pagination);
      return data;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data?.error || "UNKNOWN_ERROR");
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

export const getters = {
  getOrganizations: (state) => state.organizations,
  getPagination: (state) => state.pagination,
  isLoading: (state) => state.isLoading,
};
